import PropTypes from 'prop-types';

import { CustomTooltip } from 'src/components/CustomTooltip';

import { PROMPT_NODE_ID } from '../../../../const';

import { useStyles } from './useStyles';

export const DocumentNode = ({ element, attributes, children }) => {
  const styles = useStyles();

  return (
    <CustomTooltip
      id={PROMPT_NODE_ID.document}
      className={styles.wrapper}
      title={element.tooltip}
    >
      <span
        className={styles.root}
        {...attributes}
      >
        {children}
      </span>
    </CustomTooltip>
  );
};

DocumentNode.propTypes = {
  element: PropTypes.shape().isRequired,
  attributes: PropTypes.shape({}).isRequired,
  children: PropTypes.node,
};
DocumentNode.defaultProps = {
  children: null,
};
